// extracted by mini-css-extract-plugin
module.exports = {"notification":"__pORa","notificationViewport":"OBSp4v"};